import { formatBusinessDate } from '../../../utils/date'
import { formatMoney } from '../../../utils/amount'

// WS 2211251. A label, not a contact status: any status but Active locks the client portal.
const FinancedBadge = ({ financing }) => {
  if (!financing?.recordedAt) return null
  const details = [
    financing.lender,
    formatBusinessDate(financing.fundedAt),
    typeof financing.amount === 'number' ? formatMoney(financing.amount) : '',
  ].filter(Boolean).join(' · ')

  return (
    <span title={details}
      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold whitespace-nowrap bg-success-light text-success-main">
      Paid in full – Financed
    </span>
  )
}

export default FinancedBadge
